export interface Country {
  countryCode: string;
  name: string;
}

export const US_COUNTRY_CODE = 'US';

export enum CountryName {
  usa = 'United States',
  israel = 'Israel'
}
